import { Injectable } from '@angular/core';

import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { NotificationsService } from '@shared/services/notification';


@Injectable()
export class FSInterceptor implements HttpInterceptor { 
  constructor(private auth: AuthService, public route: Router, private toastr: NotificationsService) {
    
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {   
      const body = req.body;
      let isFileReq = req.url.indexOf("categoryimage") != -1 || req.url.indexOf("materialitemsattachment") != -1 || req.url.indexOf("serviceitemsattachment") != -1 || req.url.indexOf("estimateattachment") != -1
        || req.url.indexOf("import") != -1 || req.url.indexOf("serviceagreementitemsattachment") != -1 || req.url.indexOf("jobsiteattachment") != -1 || req.url.indexOf("workticketsattachment") != -1 || req.url.indexOf("logoimage") != -1;
      
      if (req.url.indexOf("/quickbooks/") == -1) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${this.auth.getToken()}`
            }
        });
      }

      if (!body) {
        return next.handle(req).do((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        }, (response: any) => {
          if (response instanceof HttpErrorResponse) {
            if (response.status === 401) {
              this.auth.clearStorage();
              this.route.navigate(["login"]);
              this.showErrorMessage(response.error.Message);
            } else if (response.status == 404) {
              this.toastr.error("Something went wrong!");
            }
          }
        }).catch(response => {
          if (response instanceof HttpErrorResponse) {
            if (response.status === 401) {
              this.auth.clearStorage();
              this.route.navigate(["login"]);
              this.showErrorMessage(response.error.Message);
            }
            else if (response.status === 403) {
              this.toastr.error("You don't have permission to access this");
            } else if (response.status == 503) {
              this.toastr.error("Server is unavailable");
            } else if (response.status == 404) {
              this.toastr.error("Something went wrong!");
            }
            else {
              return Observable.throw(response);
            }
          }
          return Observable.throw(response);
        });;
      }
      
      // #docregion excerpt
      // copy the body and trim whitespace from the name property
      const newBody = JSON.parse(JSON.stringify(body).replace(/(\\)?"\s*|\s+"/g, ($0, $1) => $1 ? $0 : '"'));
      // clone request and set its body
      const newReq = req.clone({ body: newBody });
      // send the cloned request to the next handler.
      return next.handle(isFileReq ? req : newReq).do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
        }
      }, (response: any) => {
        if (response instanceof HttpErrorResponse) {
          if (response.status === 401) {
            this.auth.clearStorage();
            this.route.navigate(["login"]);
            this.showErrorMessage(response.error.Message);
          }else if (response.status == 404) {
            this.toastr.error("Something went wrong!");
          }
        }
      }).catch(response => {
        if (response instanceof HttpErrorResponse) {
          if (response.status === 401) {
            this.auth.clearStorage();
            this.route.navigate(["login"]);
            //this.toastr.showMultiLineError(response.error!=undefined ? response.error.Message : "Something went wrong!", "");
            this.showErrorMessage(response.error.Message);
          }
          else if (response.status === 403) {
            this.toastr.error("You don't have permission to access this");
          } else if (response.status == 503) {
            this.toastr.error("Server is unavailable");
          }else if (response.status == 404) {
            this.toastr.error("Something went wrong!");
          }
          else {
            return Observable.throw(response);
          }
        }
        return Observable.throw(response);
      });
      // #enddocregion excerpt
    }
  showErrorMessage(message?: string) {
    this.toastr.showMultiLineError(message != undefined ? message : "Something went wrong!", "");
  }
}